const ROUTES = {
  ACTIVATE_PUSH_NOTIFICATIONS: "/activate_push",
  ALBUMS: "/albums",
  CLOSE_ACCOUNT: "/account/close",
  CLOSE_ACCOUNT_CONFIRMATION: "/account/close/confirm",
  HOME: "/",
  NOTIFICATION_SENT: "/notification/sent",
  NOTIFICATIONS: "/notifications",
  PRIVACY_POLICY: "/privacy",
  SIGN_IN: "/me",
  STICKERS: "/stickers",
  STICKER_COMPARISON: "/stickers/compare",
  STICKER_SEARCH: "/stickers/search",
  STICKER_SEARCH_RESULTS: "/stickers/search/results",
  TERMS_OF_SERVICE: "/terms",
  UPDATE_PROFILE: "/profile",
};

export default ROUTES;

export const ROUTE_PARAM_KEYS = {
  ALBUM_ID: "albumId",
  CITIES: "cities",
  NOTIFICATION_ID: "notificationId",
  NOTIFICATION_TYPE: "notificationType",
  USER_ID: "userId",
  USER_NAME: "userName",
};
